import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-annual-outcome-list',
  templateUrl: './annual-outcome-list.component.html',
  styleUrl: './annual-outcome-list.component.css'
})
export class AnnualOutcomeListComponent {
  @Input() outcomesData: any; // Adjust the type as needed
  @Input() isAffiliate: boolean;


  getMilestoneCount(milestones: any[], status: number): number {
    return milestones ? milestones.filter(milestone => milestone.status === status).length : 0;
  }
  
  
  getLabel(status: number): string {
    switch (status) {
      case 1:
        return 'Not Started';  // Custom label for status 1
      case 2:
        return 'Ongoing';  // Custom label for status 2
      case 3:
        return 'Completed'; // Custom label for status 3
      case 4:
        return 'Delayed';   // Custom label for status 4
      case 5:
        return 'Terminated';   // Custom label for status 5  
      default:
        return '';  // Default label if status is not 1, 2, or 3
    }
  }  
}
